export const geoApiHawa = {
  method: "GET",
  headers: {
    "X-RapidAPI-Key": "0f1d755db2mshcb626a1efb0cd9bp131d4fjsn4ab5e0392406",
    "X-RapidAPI-Host": "wft-geo-db.p.rapidapi.com",
  },
};

export const geoAPIURL = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const WeatherApiURL = "https://api.openweathermap.org/data/2.5";

export const WeatherAPIKEY = "df75b7272d43e963ddee8b7644b5c30c";
